import React, { useState } from "react";
import { Card } from "@material-tailwind/react";
import toast from "react-hot-toast";

export default function PublicationPopUp({
  closeModal,
  handleAddPublicationDetails,
  title,
  type,
  area,
  month,
  year,
  authors,
  publication,
  issn,
  link,
  ugc,
  citation,
  document,
}) {
  const [formData, setFormData] = useState({
    title: title || "",
    type: type || "",
    area: area || "",
    month: month || "",
    year: year || "",
    authors: authors || "",
    publication: publication || "",
    issn: issn || "",
    link: link || "",
    ugc: ugc || "no",
    citation: citation || "",
  });
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false); // Add this state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (
      !formData.title ||
      !formData.type ||
      !formData.area ||
      !formData.month ||
      !formData.year ||
      !formData.authors ||
      !formData.publication ||
      !formData.issn ||
      (!file && !document)
    ) {
      toast.error("Please fill in all required fields");
      return;
    }

    setIsSubmitting(true); // Disable button
    try {
      await handleAddPublicationDetails(formData, file);
    } finally {
      setIsSubmitting(false); // Re-enable button
    }
  };
  const monthOptions = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-80 z-50">
      <Card
        color="transparent"
        shadow={false}
        className="w-[90%] max-w-[700px] max-h-[90vh] bg-gray-900 rounded-[20px] overflow-hidden flex flex-col"
      >
        <div className="overflow-y-auto flex-1 p-6">
          <form
            onSubmit={handleSubmit}
            className="text-white flex flex-col space-y-6"
          >
            {/* Title */}
            <div className="relative z-0 w-full group">
              <label htmlFor="title" className="block text-sm">
                Title of Paper <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="title"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.title}
              />
            </div>

            {/* Paper Type */}
            <div className="relative z-0 w-full group">
              <label htmlFor="type" className="block text-sm">
                Paper Type <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="type"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.type}
              />
            </div>

            {/* Research Area */}
            <div className="relative z-0 w-full group">
              <label htmlFor="area" className="block text-sm">
                Area of Research <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="area"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.area}
              />
            </div>
            <div className="relative z-0 w-full group">
              <label htmlFor="month" className="block text-sm">
                Published Month <span className="text-red-500">*</span>
              </label>
              <select
                name="month"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.month}
              >
                <option value="">Select Month</option>
                {monthOptions.map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </select>
            </div>
            {/* Published Year */}
            <div className="relative z-0 w-full group">
              <label htmlFor="year" className="block text-sm">
                Published Year <span className="text-red-500">*</span>
              </label>
              <input
                type="number"
                name="year"
                min="1900"
                max={new Date().getFullYear()}
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.year}
              />
            </div>

            {/* Authors */}
            <div className="relative z-0 w-full group">
              <label htmlFor="authors" className="block text-sm">
                Authors <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="authors"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.authors}
              />
            </div>

            {/* Publication Name */}
            <div className="relative z-0 w-full group">
              <label htmlFor="publication" className="block text-sm">
                Name of Publication <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="publication"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.publication}
              />
            </div>

            {/* ISSN Number */}
            <div className="relative z-0 w-full group">
              <label htmlFor="issn" className="block text-sm">
                ISSN Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="issn"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.issn}
              />
            </div>

            {/* Link */}
            <div className="relative z-0 w-full group">
              <label htmlFor="link" className="block text-sm">
                Link
              </label>
              <input
                type="url"
                name="link"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.link}
              />
            </div>

            {/* UGC */}
            <div className="relative z-0 w-full group">
              <label htmlFor="ugc" className="block text-sm">
                UGC Approved <span className="text-red-500">*</span>
              </label>
              <select
                name="ugc"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
                onChange={handleChange}
                value={formData.ugc}
              >
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
            </div>

            {/* Citation */}
            <div className="relative z-0 w-full group">
              <label htmlFor="citation" className="block text-sm">
                Citation
              </label>
              <textarea
                name="citation"
                rows="3"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                onChange={handleChange}
                value={formData.citation}
              />
            </div>

            {/* Document Upload */}
            <div className="relative z-0 w-full group">
              <label htmlFor="document" className="block text-sm">
                Upload Document <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name="document"
                accept=".pdf"
                className="block py-3 px-4 w-full text-sm bg-gray-800 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                required={!document}
                onChange={handleFileChange}
              />
              {document && !file && (
                <a
                  href={`${process.env.REACT_APP_BACKEND_URL}/${document}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs text-blue-400 underline mt-1 block"
                >
                  Current file: {document.split("/").pop()}
                </a>
              )}
            </div>

            <p className="text-sm text-gray-400">
              <span className="text-red-500">*</span> compulsory fields
            </p>

            <div className="flex items-center justify-between mt-5 space-x-4">
              <button
                type="submit"
                className="w-full px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Saving..." : "Save"}
              </button>
              <button
                type="button"
                onClick={closeModal}
                className="w-full px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </Card>
    </div>
  );
}
